export default __webpack_public_path__ + "static/media/information_for_parents.d707fad7.pdf";